import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { resources } from '../../../resources/resources';
import { Link } from 'react-router-dom';

export default function Contact() {
  const { t: translate } = useTranslation();
  const { customerInfo } = useContext(CustomerInfoContext);

  const mailLink = customerInfo.isSavingsUser
    ? resources.company.savingsMailLink
    : resources.company.mailLink;
  const mail = customerInfo.isSavingsUser
    ? resources.company.savingsMail
    : resources.company.mail;
  const phoneLink = customerInfo.isSavingsUser
    ? resources.company.savingsPhoneLink
    : resources.company.phoneLink;
  const phone = customerInfo.isSavingsUser
    ? resources.company.savingsPhone
    : resources.company.phone;

  return (
    <div className="footer-contact footer-nav">
      <ul>
        <li>
          <Link to="/help">{translate(resources.footer.help)}</Link>
        </li>
        <li>
          <Link to={translate(mailLink)}>{translate(mail)}</Link>
        </li>
        <li>
          <Link to={translate(phoneLink)}>{translate(phone)}</Link>
        </li>
        <li>
          <span>
            {translate(resources.company.businessHours)}
            <br />
            {translate(resources.company.businessHoursNote)}
          </span>
        </li>
      </ul>
    </div>
  );
}
